import { Observable } from "rxjs";
import { CropService } from "../services/crop.service";
import { RequestPurposeService, RequestPurposeType } from "../services/request-purpose.service";
import { RequestStatusService, RequestStatusEnum } from "../services/request-status.service";
import { UserService } from "../services/user.service";
var ViewRequestsResolver = /** @class */ (function () {
    function ViewRequestsResolver(cropService, requestPurposeService, requestStatusService, userService) {
        this.cropService = cropService;
        this.requestPurposeService = requestPurposeService;
        this.requestStatusService = requestStatusService;
        this.userService = userService;
    }
    ViewRequestsResolver.prototype.resolve = function (_route) {
        var _this = this;
        return Observable
            .forkJoin(this.cropService.getAll(), this.userService.getAll(), this.requestPurposeService.getAll(), this.requestStatusService.getAll()).map(function (_a) {
            var crops = _a[0], users = _a[1], requestPurposes = _a[2], requestStatuses = _a[3];
            var orderedRequestStatusIds = [
                RequestStatusEnum.Draft,
                RequestStatusEnum.Submitted,
                RequestStatusEnum.Assigned,
                RequestStatusEnum.ReadyForReview,
                RequestStatusEnum.Reviewed,
                RequestStatusEnum.CreatingExperiment,
                RequestStatusEnum.ExperimentCreationError,
                RequestStatusEnum.ExperimentInProgress,
                RequestStatusEnum.Pollination,
                RequestStatusEnum.Harvest,
                RequestStatusEnum.Cancelled,
                RequestStatusEnum.None,
                RequestStatusEnum.ExperimentCompleted
            ];
            var orderedRequestPurposeIds = [
                RequestPurposeType.BiomassInFlats,
                RequestPurposeType.BiomassInPots,
                RequestPurposeType.PollinationAndImmatureHarvest,
                RequestPurposeType.PollinationAndMatureHarvest,
                RequestPurposeType.Donors
            ];
            var orderedRequestStatuses = requestStatuses.sort(function (r1, r2) {
                var r1Index = orderedRequestStatusIds.findIndex(function (or) { return or === r1.id; });
                var r2Index = orderedRequestStatusIds.findIndex(function (or) { return or === r2.id; });
                return r1Index - r2Index;
            });
            var orderedRequestPurposes = requestPurposes.sort(function (r1, r2) {
                var r1Index = orderedRequestPurposeIds.findIndex(function (or) { return or === r1.id; });
                var r2Index = orderedRequestPurposeIds.findIndex(function (or) { return or === r2.id; });
                return r1Index - r2Index;
            });
            var cropDictionary = _this.createDictionary(crops, "id");
            var userDictionary = _this.createDictionary(users, "id");
            var requestPurposeDictionary = _this.createDictionary(requestPurposes, "id");
            var requestStatusDitionary = _this.createDictionary(requestStatuses, "id");
            return {
                requestStatuses: orderedRequestStatuses,
                requestPurposes: orderedRequestPurposes,
                cropDictionary: cropDictionary,
                userDictionary: userDictionary,
                requestPurposeDictionary: requestPurposeDictionary,
                requestStatusDitionary: requestStatusDitionary
            };
        });
    };
    ViewRequestsResolver.prototype.createDictionary = function (array, indexKey) {
        var dictionary = {};
        for (var i = 0; i < array.length; i++) {
            var key = array[i][indexKey];
            dictionary[key] = array[i];
        }
        return dictionary;
    };
    return ViewRequestsResolver;
}());
export { ViewRequestsResolver };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/resolvers/view-requests.resolver.ts.pre-build-optimizer.js